import React, { Component } from 'react'
import { connect } from 'react-redux'
import Menu from '@mui/material/Menu'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import BookmarksOutlined from '@mui/icons-material/BookmarksOutlined'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import PlayArrow from '@mui/icons-material/PlayArrow'
import TextField from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search'
import { removeAccents } from '../util/stringUtil'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'

import _ from 'lodash'

import {
  COMUNICACOES,
  DOCUMENTOS,
  PROCESSOS,
  recuperarFiltrosObjetosUsuario,
  visoesComunicacoes,
  visoesDocumentos,
  visoesProcessos,
  visualizarUrlSistemaLinksPrincipais
} from '../controllers/itensController'
import styles from './MenuGerirFiltrosObjetosUsuario.module.css'
import { getUnidadesAtuaisLabel } from '../controllers/unidadesController'

export class MenuGerirFiltrosObjetosUsuario extends Component {
  constructor(props) {
    super(props)
    this.state = {
      anchorEl: null,
      filtrosObjetosUsuario: null,
      filtrarPor: ''
    }
    this.handleMenuClose = this.handleMenuClose.bind(this)
    this.handleMenuOnEnter = this.handleMenuOnEnter.bind(this)
  }

  handleMenuClose() {
    this.setState({ anchorEl: null, filtrosObjetosUsuario: null })
  }

  handleFiltrarPorChange(event) {
    this.setState({ filtrarPor: event.target.value })
  }

  handleMenuOpen(anchorEl) {
    this.setState({ anchorEl })
  }

  handleMenuOnEnter() {
    const {
      unidadesUsuario: { codigoUsuario }
    } = this.props
    const callback = (filtrosObjetosUsuario) => this.setState({ filtrosObjetosUsuario })
    recuperarFiltrosObjetosUsuario(codigoUsuario, callback)
  }

  handleVerFavoritosIconButtonClick(event) {
    this.handleMenuOpen(event.currentTarget)
  }

  handleFiltroObjetosUsuarioAplicarIconButtonClick(codigo, modulo) {
    const {
      filtros: { responsabilidadeUnidade },
      itens: {
        visao: {
          informacoesAuditor: { codigoUnidadeIntegracao }
        }
      }
    } = this.props
    const urlParams = `?redirectTo=/favoritos/${codigo}&codigoUnidadeAtual=${codigoUnidadeIntegracao}&responsabilidadeUnidade=${responsabilidadeUnidade}`
    const callback = (url) => window.open(`${url}${urlParams}`, '_blank')
    visualizarUrlSistemaLinksPrincipais(_.toLower(modulo), callback)
    this.handleMenuClose()
  }

  renderMenuIconButtons() {
    return (
      <Tooltip title='Ver favoritos'>
        <IconButton onClick={(event) => this.handleVerFavoritosIconButtonClick(event)}>
          <BookmarksOutlined color='primary' />
        </IconButton>
      </Tooltip>
    )
  }

  getNomelabelVisaoPorModulo(filterValues, modulo) {
    switch (modulo) {
      case _.toUpper(PROCESSOS):
        return visoesProcessos[filterValues]
      case _.toUpper(DOCUMENTOS):
        return visoesDocumentos[filterValues]
      case _.toUpper(COMUNICACOES):
        return visoesComunicacoes[filterValues]
      default:
        return ''
    }
  }

  getFiltrosInformados(filtrosInformados, modulo) {
    let filtrosUsedKeysLabelsValues = []
    _.mapKeys(this.getFiltrosUsedKeys(filtrosInformados), (key) => {
      const filterLabel = _.toLower(_.join(_.words(key), ' '))
      const filterValues = filtrosInformados[key]
      let filterValuesStr = null
      if (key === 'unidadesAtuais') {
        filterValuesStr = getUnidadesAtuaisLabel(filterValues)
      } else if (key === 'indicador' || key === 'destaque') {
        filterValuesStr = filterValues ? filterValues.descricao : ''
      } else if (key === 'visao') {
        filterValuesStr = this.getNomelabelVisaoPorModulo(filterValues, modulo)
      } else if (_.isArray(filterValues)) {
        filterValuesStr = _.join(
          _.map(filterValues, (value) => value.label || value.nome || value),
          ', '
        )
      } else {
        if (_.toString(filterValues) === 'true') filterValuesStr = 'Sim'
        else if (_.toString(filterValues) === 'false') filterValuesStr = 'Não'
        else filterValuesStr = filterValues
      }
      filtrosUsedKeysLabelsValues = filtrosUsedKeysLabelsValues.concat(
        `${filterLabel}${filterValuesStr ? ` "${filterValuesStr}"` : ''}`
      )
    })
    return _.join(filtrosUsedKeysLabelsValues, ', ')
  }

  getFiltrosUsedKeys(filtrosAConsiderar) {
    return _.map(
      _.filter(
        _.entries(filtrosAConsiderar),
        ([key, value]) => !_.isNil(value) && (_.size(value) || _.isBoolean(value))
      ),
      ([key]) => key
    )
  }

  getFiltrosASelecionados(valor, modulo) {
    const filtrosComunicacoes = JSON.parse(valor)
    return `Filtrar por: ${this.getFiltrosInformados(filtrosComunicacoes, modulo)}`
  }

  renderFiltrosObjetosModulo(modulo) {
    let filtros = this.renderFiltroObjetosUsuarioGridEmVisualizacao(_.toUpper(modulo))
    return _.size(filtros) ? (
      <Accordion>
        <AccordionSummary
          expandIcon={<KeyboardArrowDown />}
          aria-controls={`accordion-lista-objetos-${modulo}`}
          id={`accordion-lista-objetos-${modulo}`}
          style={{ alignItems: 'start' }}>
          <Grid container>
            <Grid
              container
              item
              xs={12}
              key={_.uniqueId(`lista-favorito-modulo${modulo}`)}
              style={{ fontWeight: 'bold', fontSize: '1rem' }}>
              {modulo}
            </Grid>
            <Grid container item xs={12}>
              {filtros[0]}
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container className={styles.colunaSumarioInterno}>
            {_.drop(filtros)}
          </Grid>
        </AccordionDetails>
      </Accordion>
    ) : null
  }

  renderFiltroObjetosUsuarioModuloGridEmVisualizacao() {
    const { filtrosObjetosUsuario } = this.state
    return _.size(filtrosObjetosUsuario) ? (
      <React.Fragment>
        {this.renderFiltrosObjetosModulo(_.toUpper(PROCESSOS))}
        {this.renderFiltrosObjetosModulo(_.toUpper(DOCUMENTOS))}
        {this.renderFiltrosObjetosModulo(_.toUpper(COMUNICACOES))}
      </React.Fragment>
    ) : null
  }

  renderFiltroObjetosUsuarioGridEmVisualizacao(moduloSistema) {
    const { filtrosObjetosUsuario, filtrarPor } = this.state
    const itensModulo = _.filter(filtrosObjetosUsuario, (item) => item.modulo === moduloSistema)
    const itemsEntriesFiltered = _.filter(itensModulo, (item) =>
      removeAccents(_.toUpper(item.descricao)).includes(removeAccents(_.toUpper(filtrarPor)))
    )
    const filtrosObjetosUsuarioSorted = _.reverse(_.sortBy(itemsEntriesFiltered, (it) => it.codigo))
    let filtros = []
    _.forEach(
      filtrosObjetosUsuarioSorted,
      (item) =>
        (filtros = filtros.concat(
          <Grid item xs={12} key={_.uniqueId(`grid-filtro-objetos-usuario-${moduloSistema}`)}>
            <Grid container justifyContent='center' className={styles.filtrosObjetosUsuarioGrid}>
              <Grid item xs={10}>
                <Tooltip
                  placement='bottom-start'
                  title={this.getFiltrosASelecionados(item.valor, item.modulo)}
                  classes={{ tooltip: styles.tooltipDetalharFavorito }}>
                  <Typography>{item.descricao}</Typography>
                </Tooltip>
              </Grid>
              <Grid item xs={2}>
                <Grid container justifyContent='flex-end'>
                  <Tooltip title='Aplicar'>
                    <IconButton
                      id='filtro-objetos-usuario-aplicar-icon-button'
                      size='small'
                      onClick={() =>
                        this.handleFiltroObjetosUsuarioAplicarIconButtonClick(
                          item.codigo,
                          item.modulo
                        )
                      }>
                      <PlayArrow color='primary' />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))
    )
    return filtros
  }

  renderMenuHeaderEmVisualizacao() {
    const { filtrosObjetosUsuario } = this.state
    return _.size(filtrosObjetosUsuario) ? (
      <Grid item xs={11}>
        <Typography>
          {`Foram encontrados ${_.size(filtrosObjetosUsuario)} filtros previamente salvos como favoritos.`}
        </Typography>
      </Grid>
    ) : !_.isNil(filtrosObjetosUsuario) && _.size(filtrosObjetosUsuario) === 0 ? (
      <Grid container item xs={11}>
        <Typography>Não foram encontrados favoritos salvos por você.</Typography>
      </Grid>
    ) : null
  }

  renderMenu() {
    const { anchorEl, filtrarPor } = this.state
    return (
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        TransitionProps={{ onEnter: this.handleMenuOnEnter }}
        onClose={this.handleMenuClose}
        MenuListProps={{ component: 'div' }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Paper elevation={0} square className={styles.paper}>
          <Grid container justifyContent='center' spacing={1}>
            <Grid item xs={6}>
              <Typography variant='h6' color='primary' style={{ margin: '16px 0' }}>
                Favoritos
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <TextField
                onKeyDown={(event) => event.stopPropagation()}
                id='filtrarPorItems'
                type='search'
                className={styles.filtrarPorTextField}
                label={
                  <div style={{ alignItems: 'start', display: 'flex' }}>
                    <SearchIcon style={{ height: 18 }} />
                    Pesquisar
                  </div>
                }
                value={filtrarPor}
                onChange={(event) => this.handleFiltrarPorChange(event)}
              />
            </Grid>
            {this.renderMenuHeaderEmVisualizacao()}
            <Grid item xs={11} />
          </Grid>
          <Grid container justifyContent='center' style={{ marginBottom: 32 }}>
            <Grid item xs={11}>
              {this.renderFiltroObjetosUsuarioModuloGridEmVisualizacao()}
            </Grid>
          </Grid>
        </Paper>
      </Menu>
    )
  }

  render() {
    return (
      <React.Fragment>
        <Grid container item xs={12} alignItems='center'>
          {this.renderMenuIconButtons()}
        </Grid>
        {this.renderMenu()}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ filtros, itens, unidadesUsuario }) => ({
  filtros,
  itens,
  unidadesUsuario
})

export default connect(mapStateToProps)(MenuGerirFiltrosObjetosUsuario)
